"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f32321 = void 0;
exports.f32321 = {
    "繁體中文": [
        9040
    ]
};
